<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                <chevron
                  @click="$router.push({name: 'NotificationMessageManagement'})"/>
                {{
                  isEdition() ? $t('health.notificationMessages.editMessage') : $t('health.notificationMessages.addMessage')
                }}
              </h1>
              <alert
                v-if="alertVisible"
                :message="alertMessage"
                :type="alertType">
              </alert>
            </div>
          </grid-col>
        </grid-row>
        <form
          v-on:submit.prevent
          v-on:keypress.enter.prevent="onSave"
          v-on:keydown.space.prevent="'false'">
          <grid-row column-align="center">
            <grid-col col-size="4">
              <label-input
                :lowercase="false"
                :disabled="isEdition()"
                ref="messageCodeInput"
                form-size="m"
                :label="$t('health.notificationMessages.messageCode')"
                v-model="messageCode"
                :type="'text'"
                :error="mesageCodeErrorLenght || mesageCodeErrorUnique"
                :errorMessage="displayMessageCodeErrorMessage">
              </label-input>
            </grid-col>
          </grid-row>

          <grid-row column-align="center">
            <grid-col col-size="4">
              <vue-single-select
                :placeholder="''"
                class="selection-left"
                v-model="selectedType"
                v-on:input="changeType"
                :options="getTypes"
                :option-label="'label'"
                />
            </grid-col>
          </grid-row>

          <grid-row column-align="center" v-if="isOther" col-spaced class="margin-top-m">
            <grid-col col-size="2">
              <label-input
                ref="typeInput"
                form-size="m"
                :label="$t('health.notificationMessages.type')"
                v-model="type"
                :type="'text'"
                :error="typeError"
                :errorMessage="$t('commons.mandatoryFieldMessage')">
              </label-input>
            </grid-col>

            <grid-col col-size="2">
              <label-input
                ref="typeInput"
                form-size="m"
                :label="$t('health.notificationMessages.typeEng')"
                v-model="typeEng"
                :type="'text'"
                :error="typeEngError"
                :errorMessage="$t('commons.mandatoryFieldMessage')">
              </label-input>
            </grid-col>
          </grid-row>

          <grid-row column-align="center" class="margin-top-m">
            <grid-col col-size="4">
              <checkbox
                id="in-app-enabled"
                :label="$t('health.notificationMessages.inApp')"
                v-on:change="onInAppChange"
                :checked="inApp">
              </checkbox>
            </grid-col>
          </grid-row>

          <grid-row column-align="center" col-spaced v-if="inApp">
            <grid-col col-size="2">
              <label-textarea
                ref="inAppMessageInput"
                form-size="s"
                :label="$t('health.notificationMessages.inAppMessage')"
                v-model="messageText"
                :error="inAppMessageError"
                :errorMessage="$t('commons.mandatoryFieldMessage')"
              >
              </label-textarea>
            </grid-col>
            <grid-col col-size="2">
              <label-textarea
                ref="inAppMessageEngInput"
                form-size="s"
                :label="$t('health.notificationMessages.inAppMessageEng')"
                v-model="messageTextEng"
                :error="inAppMessageEngError"
                :errorMessage="$t('commons.mandatoryFieldMessage')">
              </label-textarea>
            </grid-col>
          </grid-row>

          <grid-row column-align="center">
            <grid-col col-size="4">
              <checkbox
                id="push-enabled"
                :label="$t('health.notificationMessages.push')"
                v-on:change="onPushChange"
                :checked="push">
              </checkbox>
            </grid-col>
          </grid-row>

          <grid-row column-align="center" col-spaced v-if="push">
            <grid-col col-size="2">
              <label-textarea
                ref="pushMessageInput"
                form-size="s"
                :label="$t('health.notificationMessages.pushMessage')"
                v-model="pushMessageText"
                :error="pushMessageTextError"
                :errorMessage="$t('commons.mandatoryFieldMessage')"
              >
              </label-textarea>
            </grid-col>
            <grid-col col-size="2">
              <label-textarea
                ref="pushMessageEngInput"
                form-size="s"
                :label="$t('health.notificationMessages.pushMessageEng')"
                v-model="pushMessageTextEng"
                :error="pushMessageTextEngError"
                :errorMessage="$t('commons.mandatoryFieldMessage')">
              </label-textarea>
            </grid-col>
          </grid-row>

          <grid-row column-align="center">
            <grid-col col-size="4">
              <div class="variable-input-field submit-buttons align-right">
                <btn-pill
                  :btnText="$t('commons.cancel')"
                  v-on:click="onCancel"
                  btn-size="m"
                  btn-type="secondary">
                </btn-pill>
                <btn-pill
                  :btnText="$t('commons.save')"
                  v-on:click="onSave"
                  btn-size="m">
                </btn-pill>
              </div>
            </grid-col>
          </grid-row>
        </form>
      </div>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import Chevron from '@/components/shared/Chevron';
import Alert from '@/components/shared/alert/Alert';
import LabelInput from '@/components/shared/forms/LabelInput';
import LabelTextarea from '@/components/shared/forms/LabelTextarea';
import BtnPill from '@/components/shared/buttons/BtnPill';
import Checkbox from '@/components/shared/forms/Checkbox';
import VueSingleSelect from 'vue-single-select';
import api from 'BRAND/api/notification';

export default {

  components: {
    MainLayout,
    GridRow,
    GridCol,
    Chevron,
    Alert,
    LabelInput,
    LabelTextarea,
    BtnPill,
    Checkbox,
    VueSingleSelect
  },
  data () {
    return {
      message: {},
      messageCode: '',
      selectedType: null,
      type: '',
      typeEng: '',
      messageText: '',
      messageTextEng: '',
      pushMessageText: '',
      pushMessageTextEng: '',
      inApp: false,
      push: false,
      /* Errors */
      mesageCodeErrorUnique: false,
      mesageCodeErrorLenght: false,
      inAppMessageError: false,
      inAppMessageEngError: false,
      pushMessageTextError: false,
      pushMessageTextEngError: false,
      typeError: false,
      typeEngError: false,
      /* UI controls */
      alertVisible: false,
      alertMessage: '',
      alertType: '' // error, warning, success
    };
  },
  created () {
    this.message = this.$route.params;
    this.selectedType = this.getTypes[0];
    if (this.isEdition()) {
      this.messageCode = this.message.messageCode;
      this.selectType();
      this.messageText = this.message.message;
      this.messageTextEng = this.message.messageEng;
      this.pushMessageText = this.message.pushMessage;
      this.pushMessageTextEng = this.message.pushMessageEng;
      this.inApp = this.message.inApp;
      this.push = this.message.push;
    }
  },
  computed: {
    getBreadcrumb () {
      const self = this.isEdition() ? this.$t('health.notificationMessages.editMessage') : this.$t('health.notificationMessages.addMessage');
      return [
        {name: this.$t('menu.settings'), link: '/settings'},
        {name: this.$t('health.notificationMessages.title'), link: '/notification-messages'},
        {name: self, link: '/notification-messages/edit', disabled: true}
      ];
    },
    getTypes () {
      return [
        {
          id: 0,
          label: this.$t('health.notificationMessages.types.glucose'),
          alias: 'glucose',
          en: 'Glucose',
          es: 'Glucosa'
        },
        {
          id: 1,
          label: this.$t('health.notificationMessages.types.nutrition'),
          alias: 'nutrition',
          en: 'Nutrition',
          es: 'Alimentación'
        },
        {
          id: 2,
          label: this.$t('health.notificationMessages.types.activity'),
          alias: 'activity',
          en: 'Activity',
          es: 'Actividad'
        },
        {
          id: 3,
          label: this.$t('health.notificationMessages.types.vibeBattery'),
          alias: 'vibeBattery',
          en: 'VibeBattery',
          es: 'VibeBattery'
        },
        {id: 4, label: this.$t('health.notificationMessages.types.rest'), alias: 'rest', en: 'Rest', es: 'Descanso'},
        {
          id: 5,
          label: this.$t('health.notificationMessages.types.questionnaire'),
          alias: 'questionnaire',
          en: 'Questionnaire',
          es: 'Cuestionario'
        },
        {
          id: 6,
          label: this.$t('health.notificationMessages.types.challenge'),
          alias: 'challenge',
          en: 'Challenge',
          es: 'Reto'
        },
        {
          id: 7,
          label: this.$t('health.notificationMessages.types.happyBirthday'),
          alias: 'birthday',
          en: '¡Feliz cumpleaños Viber!',
          es: 'Happy Birthday Viber!'
        },
        {id: 8, label: this.$t('health.notificationMessages.types.other'), alias: 'other'}
      ];
    },
    displayMessageCodeErrorMessage () {
      let errorMessage = this.$t('commons.mandatoryFieldMessage');
      if (this.mesageCodeErrorUnique) {
        errorMessage = this.$t('health.notificationMessages.messageCodeAlreadyExists');
      }
      return errorMessage;
    },
    isOther () {
      return this.selectedType !== null && this.selectedType.alias === 'other';
    }
  },
  methods: {
    isEdition () {
      return this.message.id !== undefined;
    },
    onCancel () {
      this.$router.push({name: 'NotificationMessageManagement'});
    },
    onSave () {
      clearErrors(this);
      if (isValidForm(this)) {
        const body = {};
        body.messageCode = this.messageCode;
        if (this.isOther) {
          body.type = this.type;
          body.typeEng = this.typeEng;
        } else {
          body.type = this.selectedType.es;
          body.typeEng = this.selectedType.en;
        }
        body.message = this.messageText;
        body.messageEng = this.messageTextEng;
        body.pushMessage = this.pushMessageText;
        body.pushMessageEng = this.pushMessageTextEng;
        body.inApp = this.inApp;
        body.push = this.push;

        if (this.isEdition()) {
          body.id = this.message.id;
          api.updateMessage(this, body)
            .then(() => {
              const msg = this.$t('health.notificationMessages.messageSuccessfullyUpdated');
              this.$router.replace({ name: 'NotificationMessageManagement', params: {alert: msg} });
            }, (error) => {
              showAlert(this, error.body.message, 'error');
            });
        } else {
          api.createMessage(this, body)
            .then(() => {
              const msg = this.$t('health.notificationMessages.messageSuccessfullyCreated');
              this.$router.replace({ name: 'NotificationMessageManagement', params: {alert: msg} });
            }, (error) => {
              if (error.body.message.includes('message with that code already exists')) {
                this.mesageCodeErrorUnique = true;
              } else {
                showAlert(this, error.body.message, 'error');
              }
            });
        }
      }
    },
    onInAppChange (value) {
      this.inApp = value;
    },
    onPushChange (value) {
      this.push = value;
    },
    changeType (value) {
      this.selectedType = value;
    },
    selectType () {
      const foundType = this.getTypes.find(elem => elem.es === this.message.type || elem.en === this.message.type);
      if (foundType !== undefined) {
        this.selectedType = foundType;
      } else {
        this.selectedType = this.getTypes.find(elem => elem.alias === 'other');
        this.type = this.message.type;
        this.typeEng = this.message.typeEng;
      }
    }
  }
};

const clearErrors = (context) => {
  context.mesageCodeErrorUnique = false;
  context.mesageCodeErrorLenght = false;
  context.inAppMessageError = false;
  context.inAppMessageEngError = false;
  context.pushMessageTextError = false;
  context.pushMessageTextEngError = false;
  context.typeError = false;
  context.typeEngError = false;
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 2000);
};

const isValidForm = (context) => {
  let valid = true;
  if (!(context.messageCode && context.messageCode.length > 0)) {
    valid = false;
    context.mesageCodeErrorLenght = true;
  }
  if (context.selectedType.alias === 'other') {
    if (!(context.type && context.type.length > 0)) {
      valid = false;
      context.typeError = true;
    }
    if (!(context.typeEng && context.typeEng.length > 0)) {
      valid = false;
      context.typeEngError = true;
    }
  }
  if (context.inApp) {
    if (!(context.messageText && context.messageText.length > 0)) {
      valid = false;
      context.inAppMessageError = true;
    }

    if (!(context.messageTextEng && context.messageTextEng.length > 0)) {
      valid = false;
      context.inAppMessageEngError = true;
    }
  }
  if (context.push) {
    if (!(context.pushMessageText && context.pushMessageText.length > 0)) {
      valid = false;
      context.pushMessageTextError = true;
    }

    if (!(context.pushMessageTextEng && context.pushMessageTextEng.length > 0)) {
      valid = false;
      context.pushMessageTextEngError = true;
    }
  }
  return valid;
};

</script>

<style lang="scss">
@import "src/stylesheets/variables";

</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/notifications/EditNotificationMessage.vue